import { Checkbox } from "@certa/catalyst/components/Checkbox";
import { Stack } from "@certa/catalyst/layouts/Stack";
import { useSearchStore } from "../../store/useSearchStore";
import { filtersStyles } from "./Filters.style";
import { Spinner } from "@certa/icons/components/Spinner";
import { classNames } from "@certa/catalyst/utils/common";
import { useGetObjectTypeTranslations } from "@certa/queries/hooks/dataObjects.hooks";
import {
  Typography,
  TypographyColors,
  TypographyVariants
} from "@certa/catalyst/components/Typography";
import { useIntl } from "react-intl";
import { useGetDataObjectOptions } from "../../hooks/useGetDataObjectOptions";
import { AnalyticsEvents, analyticsService } from "@certa/analytics";

type DataObjectFilterProps = {
  isDisabled?: boolean;
};

const DataObjectFilter = ({ isDisabled }: DataObjectFilterProps) => {
  const { filters, setFilters } = useSearchStore();
  const intl = useIntl();

  const { data: dataObjects, isLoading: isLoadingDataObjects } =
    useGetObjectTypeTranslations({
      config: {
        enabled: true
      }
    });

  const dataObjectOptions = useGetDataObjectOptions(dataObjects);

  const handleChange = (
    dataObjectId: string,
    label: string,
    checked: boolean
  ) => {
    analyticsService.track(
      AnalyticsEvents.globalSearchEvents.GLOBAL_SEARCH_CATEGORY_SELECT,
      {
        value: label,
        checked,
        certa_version: "OS3",
        type: "data_object_type"
      }
    );
    const dataObjectTags = filters.dataObjectTags.includes(dataObjectId)
      ? filters.dataObjectTags.filter(id => id !== dataObjectId)
      : [...filters.dataObjectTags, dataObjectId];
    setFilters({ dataObjectTags });
  };

  const noDataObjectsFoundLabel = intl.formatMessage({
    id: "globalSearch.noOptionsFoundLabel",
    defaultMessage: "No options found"
  });

  return (
    <Stack
      gap="4"
      dangerouslySetClassName={classNames(
        filtersStyles.kindFilterWrapper,
        "scrollbar-on-hover"
      )}
    >
      {isLoadingDataObjects ? (
        <Stack
          direction="horizontal"
          align="center"
          justify="center"
          height="3rem"
        >
          <Spinner />
        </Stack>
      ) : dataObjectOptions.length ? (
        dataObjectOptions.map(option => (
          <Checkbox
            key={option.value}
            label={option.label}
            value={option.value}
            checked={filters.dataObjectTags.includes(option.value)}
            onChange={checked =>
              handleChange(option.value, option.label, checked)
            }
            disabled={isDisabled}
          />
        ))
      ) : (
        <Typography
          variant={TypographyVariants.BODY}
          color={TypographyColors.NEUTRAL_700}
        >
          {noDataObjectsFoundLabel}
        </Typography>
      )}
    </Stack>
  );
};

export { DataObjectFilter };
